module.exports = __webpack_public_path__ + "static/media/weather-icon.e1a75254.jpg";